import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import Checkout from '../../../Components/Payments/Checkout';
import { StyledButton } from '../../../Components/Generics.styled';

const AdServicesCheckoutContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const Title = styled.div`
    margin-top: 100px;
    font-size: 30px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    text-align: center;
`;

const CheckoutSection = styled.div`
    margin-top: 50px;
    width: 400px;
    display: flex;
    flex-direction: column;
`;

const Label = styled.span`
    font-weight: bold;
`;

const TotalSection = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;
    font-size: 30px;
    font-weight: bold;
`;

const StyledNavButtons = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;

    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;
const AdServicesCheckout = ({ currentAdvertiser, history, selectedService, selectedTiers, handleCheckout, handleAfterCheckout }) => {
    const { adServiceName, adServiceDescription } = { ...selectedService };
    const TierOption = Object.keys(selectedTiers)?.map((item, idx) => item)[0];
    const TierPrice = selectedTiers[TierOption]?.price;
    const taxPercent = 6;

    return (
        <AdServicesCheckoutContainer>
            <Title>Checkout</Title>
            <Checkout
                currentAdvertiser={currentAdvertiser}
                price={TierPrice}
                itemName={adServiceName}
                itemDescription={adServiceDescription}
                taxPercent={taxPercent}
                onCheckout={handleCheckout}
                afterCheckout={handleAfterCheckout}
            />
            <StyledNavButtons>
                <StyledButton variant="contained" color="primary" onClick={() => history.push('/portal/adServices/details')}>
                    Back
                </StyledButton>
            </StyledNavButtons>
        </AdServicesCheckoutContainer>
    );
};

AdServicesCheckout.propTypes = {
    currentAdvertiser: propTypes.shape({}),
    handleCheckout: propTypes.func,
    handleAfterCheckout: propTypes.func,
    history: propTypes.shape({ push: propTypes.func }),
    selectedService: propTypes.shape({
        adServiceName: propTypes.string,
        adServiceDescription: propTypes.string,
    }),
    selectedTiers: propTypes.shape({}),
};

AdServicesCheckout.defaultProps = {
    selectedProducts: {},
};
export default AdServicesCheckout;
